/*
 * File: d:\projects\AutoFiFront\src\Content\HeaderCart\HeaderCart.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday February 24th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday February 24th 2023 5:31:18 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from "react";
import style from 'Content/HeaderCart/HeaderCart.module.css';
import CartSVG from "Content/SVG/OtherSVG/CartSVG";
import RouterPathResolver from "Config/Router/RouterPathResolver";

type HeaderCartType = {
    ids: number[] | null,
    themeColor: string,
};

function HeaderCart (props: HeaderCartType){
    const fillColor = props.themeColor== "CITYCAR" ? "var(--root-colors-second)" : props.themeColor == "SUV" ? "var(--root-colors-third)" : props.themeColor == "UTILITY" ? "var(--root-colors-fourth)" : props.themeColor == "SEDAN" ? "var(--root-colors-fifth)" : props.themeColor == "BREAK" ? "var(--root-colors-sixth)" : "var(--root-colors-first)";

    return(
        <React.Fragment>
            <a href={RouterPathResolver.routeCart.path} aria-label="Open Cart" className={`${style.linkCart}`}>
                {
                    props.ids != undefined && props.ids.length != 0 ?
                    <div className={`${style.cartHolder}`}>
                        <span className={`${style.spanPos}`}>
                            {props.ids.length}
                        </span>
                        <CartSVG width="3rem" fill={fillColor}/>
                    </div>
                    :
                    <CartSVG width="3rem" fill={"none"} strokeWidth={"30px"} stroke={fillColor}/>
                }
            </a>
        </React.Fragment>
    );
}

export default HeaderCart;
